import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, submit, Form } from "redux-form";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  FormControlLabel,
  TextField,
  withMobileDialog,
  withStyles,
  Checkbox,
  Grid
} from "@material-ui/core";
import * as AccountActions from "../../../../store/AccountHierarchy";
import * as SnackbarActions from "../../../../store/SnackbarStore";
import {
  CreateScenarios,
  UpdateScenarios
} from "../../../../services/dataService";
import styles from "../../../../wrappers/admin/Admin.Styles";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength256 = maxLength(256);

const validate = values => {
  const errors = {};
  const requiredFields = ["name"];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  const maxLengthFields = ["name", "alias"];
  maxLengthFields.forEach(field => {
    if (maxLength256(values[field])) {
      errors[field] = maxLength256(values[field]);
    }
  });

  return errors;
};

const renderTextField = ({
  input,
  label,
  name,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <TextField
      name={name}
      label={label}
      helperText={touched && error}
      error={touched && error !== undefined}
      {...input}
      {...custom}
      margin="normal"
    />
  );
};

const renderCheckbox = ({ input, label, name, ...custom }) => {
  //debugger;
  return (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          label={label}
          {...input}
          checked={input.value}
          value={input.value ? "yes" : "no"}
          {...custom}
        />
      }
      label={label}
    />
  );
};

export const ScenarioFormMode = Object.freeze({
  CREATE: Symbol("create"),
  EDIT: Symbol("edit")
});

class ScenarioForm extends Component {
  handleSubmit = async scenario => {
    const { sendError } = this.props;

    try {
      const mode =
        scenario.id > 0 ? ScenarioFormMode.EDIT : ScenarioFormMode.CREATE;
      const result =
        scenario.id > 0
          ? await UpdateScenarios(scenario)
          : await CreateScenarios(scenario);

      if (result) {
        this.props.submitted(result, mode);
      }
    } catch (error) {
      console.log(error);
      sendError(error);
    }
  };

  render() {
    const { classes, handleSubmit } = this.props;

    return (
      <div className={classes.root}>
        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          <Grid container spacing={24} />
          <Grid item xs={12}>
            <Field
              name="name"
              component={renderTextField}
              label="Name"
              className={classes.textFieldMed}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="alias"
              component={renderTextField}
              label="Alias"
              className={classes.textFieldMed}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="isActive"
              component={renderCheckbox}
              label="Active"
              className={classes.checkbox}
            />
          </Grid>
        </Form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    initialValues: state.scenarios.data
  };
}

ScenarioForm = connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        SnackbarActions.actionCreators,
        AccountActions.actionCreators
      ),
      dispatch
    )
)(
  reduxForm({
    form: "ScenarioForm",
    validate
  })(withStyles(styles)(ScenarioForm))
);

class ScenarioModalForm extends Component {
  state = {
    scenario: {
      id: 0,
      name: "",
      alias: ""
    }
  };

  getTitle = () => {
    return this.state.scenario.id ? "Edit Scenario" : "Add Scenario";
  };

  componentDidMount() {
    const { initialValues } = this.props;
    this.setState({ scenario: { ...initialValues } });
  }

  render() {
    const { open, fullscreen, handleClose, dispatch } = this.props;

    return (
      <Dialog
        fullscreen={fullscreen}
        open={open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {this.getTitle()}
        </DialogTitle>
        <DialogContent>
          <ScenarioForm submitted={handleClose} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(submit("ScenarioForm"));
            }}
            color="primary"
          >
            Ok
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ScenarioModalForm.propTypes = {
  open: PropTypes.bool.isRequired
};

export default connect(state => ({
  initialValues: state.scenarios.data
}))(withStyles(styles)(withMobileDialog()(ScenarioModalForm)));
